import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { filter } from 'rxjs/operators';
import { TableType } from 'src/shared/enums';
import ICalibrationUsesLabel = ZoneIQCalibration.ICalibrationUsesLabel;
import { ZoningCodeService } from '../../core/services';
import { LoaderService } from 'src/shared/services';
import { ImportService } from '../../core/services/import.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../../shared/zoneiqui/components';
import { Subscription } from 'rxjs';
import { IZoningCodeModel } from 'src/app/interfaces/zoning-code-model.interface';

@Component({
    standalone: false,
    selector: 'data-import',
    templateUrl: './data-import.component.html',
    styleUrls: ['./data-import.component.scss']

})
export class DataImportComponent implements OnInit, OnDestroy {

    @Input()
     currentTab: string;

    @Input()
     tableType: TableType;

     subscription = new Subscription();
     zoningCode: IZoningCodeModel = null;
     usesData: ICalibrationUsesLabel[] = null;


    constructor(
        private readonly zcService: ZoningCodeService,
        private readonly importService: ImportService,
        private readonly loaderService: LoaderService,
        private readonly dialog: MatDialog) { }

    get table() {
        if (!this.zoningCode) {
            return null;
        }
        return this.usesData;
    }

     get zoningCodeId() {
        return this.zcService.zoningCodeId;
    }

    get canImport() {
        return this.importService.areThereUsesLabels &&
            this.importService.canImportUsesLabels();
    }

    ngOnInit() {
        this.loaderService.show();
        this.zcService.zoningCodes.pipe(filter(zc => zc !== null && zc.length > 0)).subscribe(zc => {
            this.zoningCode = zc[0];
            if (!this.zoningCode) {
                return;
            }
            this.loaderService.hide();
        });

        switch (this.tableType) {
            case TableType.CALIBRATION_USES:
                this.subscription.add(this.importService.usesData$
                    .subscribe((usesTables: ICalibrationUsesLabel[]) => this.usesData = usesTables));
                break;
        }
    }

    importData() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '30%';
        dialogConfig.data = {
            title: 'Import data',
            topContent: `Current uses will be imported to Zoning Code. Continue?`
        };

        const importDialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        importDialogRef.afterClosed()
            .subscribe((needToImport) => {
                if (!needToImport) {
                    return;
                }
                this.importService.importUses();
            });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}
